import { render, staticRenderFns } from "./goodsFollow.vue?vue&type=template&id=82081c54&"
import script from "./goodsFollow.vue?vue&type=script&lang=js&"
export * from "./goodsFollow.vue?vue&type=script&lang=js&"
import style0 from "./goodsFollow.vue?vue&type=style&index=0&id=82081c54&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82081c54')) {
      api.createRecord('82081c54', component.options)
    } else {
      api.reload('82081c54', component.options)
    }
    module.hot.accept("./goodsFollow.vue?vue&type=template&id=82081c54&", function () {
      api.rerender('82081c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/goodsFollow.vue"
export default component.exports